export default __webpack_public_path__ + "b1312f76d6c6a7d2be6db52120fe0e4f.png";